import styled from '@emotion/styled'

export const Step = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border: solid 1px rgb(230, 230, 230);
  border-radius: 5px;
  margin-bottom: 5px;
`

export const Label = styled.span`
  display: block;
  font-weight: bold;
  color: rgb(120, 120, 120);
  font-size: 14px;
  padding-bottom: 5px;
`

export const Value = styled.span`
  &.zero {
    font-weight: bold;
    color: rgb(120, 120, 120);
  }

  &.negative {
    font-weight: bold;
    color: #f44336;
  }

  &.positive {
    font-weight: bold;
    color: #2196f3;
  }
`
